'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const Formatters=require('../../../../dist-es6/client/formatters');let

GraphGuideLinesDirective=function(_BaseControllerBacked){_inherits(GraphGuideLinesDirective,_BaseControllerBacked);function GraphGuideLinesDirective(){_classCallCheck(this,GraphGuideLinesDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(GraphGuideLinesDirective,[{key:'objectBindings',get:function()
{
return['plotArea','verticalAxis','horizontalAxis','timezone'];
}},{key:'textBindings',get:function()

{
return[];
}},{key:'controller',get:function()

{
return GraphGuideLinesDirectiveController;
}}]);return GraphGuideLinesDirective}(BaseControllerBackedDirective);let


GraphGuideLinesDirectiveController=function(){_createClass(GraphGuideLinesDirectiveController,null,[{key:'$inject',get:function()
{return['$scope','$element','$timeout','$window','dateService']}}]);

function GraphGuideLinesDirectiveController($scope,$element,$timeout,$window,dateService){var _this2=this;_classCallCheck(this,GraphGuideLinesDirectiveController);
this._$scope=$scope;
this._dateService=dateService;

$scope.$watch('controller.plotArea',function(){
if(_.exists(_this2.plotArea)){
_this2.plotArea.registerPlotter(_this2);
}
});
}GraphGuideLinesDirectiveController.prototype.









redraw=function redraw(){
if(!this._scalesValid){
return;
}

let dayBreakTicks=d3.select(this.plotArea.svgElement).insert('g').attr({
class:'day-break-lines',
transform:`translate(0, ${this.plotArea.dimensions.height})`}).
call(this._drawDayBreakLines());

dayBreakTicks.
selectAll('text').
style({"text-anchor":'start'}).
each(function(){
this.innerHTML=d3.select(this).
text().
split(' ').
map(function(t,i){return`<tspan${t===_todayText?' class="today"':''}>${i===0?t.toUpperCase():t}</tspan>`}).
join(' ');
});

let fatigueGroup=d3.select(this.plotArea.svgElement).append('g').attr({
class:'fatigue-guide-lines',
transform:`translate(${this.plotArea.dimensions.width}, 0)`});


let fatigueTicks=fatigueGroup.call(this._drawFatigueGuideLines());
d3.select(_.first(fatigueTicks.selectAll('.tick')[0])).attr('visibility','hidden');

fatigueGroup.append('text').
attr({
class:'axis-label',
transform:'rotate(-90)',
y:-this.plotArea.graphAreaDimensions.width,
x:-this.plotArea.graphAreaDimensions.height,
dy:'-30px',
"text-anchor":'start'}).

text('Fatigue');
};GraphGuideLinesDirectiveController.prototype.
_drawDayBreakLines=function _drawDayBreakLines(){var _this3=this;
const zonedDayIntervals=this.horizontalAxis.domain.getSpanningIntervals('days',1,this.timezone);
const today=zonedDayIntervals.find(function(i){return i.contains(_this3._dateService.now())});

return d3.svg.axis().
scale(this.horizontalAxis.scale).
orient('top').
tickValues(zonedDayIntervals.map(function(i){return i.start})).
tickFormat(function(time){return _.exists(today)&&today.start===time?
_todayText:
Formatters.formatInLocale(time,'ddd MMM DD',_this3.timezone,{displayTimeZone:!1})}).
innerTickSize(this.plotArea.graphAreaDimensions.height).
outerTickSize(0);
};GraphGuideLinesDirectiveController.prototype.

_drawFatigueGuideLines=function _drawFatigueGuideLines(){
return d3.svg.axis().
scale(this.verticalAxis.scale).
orient('left').
ticks(5).
innerTickSize(this.plotArea.graphAreaDimensions.width).
outerTickSize(0);
};_createClass(GraphGuideLinesDirectiveController,[{key:'_scalesValid',get:function(){return _.exists(this.horizontalAxis)&&_.exists(this.horizontalAxis.scale)&&_.exists(this.verticalAxis)&&_.exists(this.verticalAxis.scale)}}]);return GraphGuideLinesDirectiveController}();


const _todayText='Today';

module.exports=GraphGuideLinesDirective;
//# sourceMappingURL=graphGuideLinesDirective.js.map
